import { Box, Typography } from '@mui/material';
import React from 'react';
import BtnComponent from '../buttonComponent/BtnComponent';
import { DrawerBoxComponent } from '../DrawerBoxComponent/DrawerBoxComponent';
import { APPOINTMENTS } from '../../shared/Strings';

export const AppointmentVisitLink = ({ visitLink }) => {
  return (
    <DrawerBoxComponent>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 2,
        }}>
        <Typography variant="navSelected">{APPOINTMENTS.VISIT_LINK}</Typography>
        <BtnComponent
          title={APPOINTMENTS.BUTTON_TEXT.JOIN_VISIT}
          target="_blank"
          href={visitLink}
          rel="noopener"
          disabled={!visitLink}
        />
      </Box>
    </DrawerBoxComponent>
  );
};
